import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useMemo, useState } from 'react'
import { getTools, getMedicationsTypeIntake, PointManipulationInterface, getPointManipulation, setPointManipulationUsertaskproceedType1, setPointManipulationUsertaskproceedType2, getPointManipulationUsertaskproceed } from '../../../../api/chatApi/chatApi'
import SimpleCard from '../../../common/SimpleCard'
import DetailViewBtnContainerManipulation from './DetailViewBtnContainerManipulation'
import Plan3d from '../../../../assets/img/model-plans/plan-3d.svg'
import Plan3dDisbaled from '../../../../assets/img/model-plans/plan-3d-disabled.svg'
import Body from '../../../../assets/img/model-plans/plan-body.png'
import BodyDisbaled from '../../../../assets/img/model-plans/plan-body-disabled.png'
import Head from '../../../../assets/img/model-plans/plan-part-head.png'
import HeadDisabled from '../../../../assets/img/model-plans/plan-part-head-disabled.png'
import Chest from '../../../../assets/img/model-plans/plan-part-chest.png'
import ChestDisabled from '../../../../assets/img/model-plans/plan-part-chest-disabled.png'
import Stomach from '../../../../assets/img/model-plans/plan-part-stomach.png'
import StomachDisabled from '../../../../assets/img/model-plans/plan-part-stomach-disabled.png'
import AnkleJoints from '../../../../assets/img/model-plans/ankleJoints.png'
import AnkleJointsDisabled from '../../../../assets/img/model-plans/ankleJoints_diabled.png'
import Pelvis from '../../../../assets/img/model-plans/pelvis.png'
import PelvisDisabled from '../../../../assets/img/model-plans/pelvis_disabled.png'
import Elbow from '../../../../assets/img/model-plans/elbow.png'
import ElbowDisabled from '../../../../assets/img/model-plans/elbow_disabled.png'
import Feet from '../../../../assets/img/model-plans/feet.png'
import FeetDisabled from '../../../../assets/img/model-plans/feet_disabled.png'
import Hands from '../../../../assets/img/model-plans/hands.png'
import HandsDisabled from '../../../../assets/img/model-plans/hands_disabled.png'
import Knee from '../../../../assets/img/model-plans/knee.png'
import KneeDisabled from '../../../../assets/img/model-plans/knee_disabled.png'
import Photo from '../../../../assets/img/model-plans/photo.png'
import PhotoDisabled from '../../../../assets/img/model-plans/photo_disabled.png'
import Shoulder from '../../../../assets/img/model-plans/shoulder.png'
import ShoulderDisabled from '../../../../assets/img/model-plans/shoulder_disabled.png'
import CircleEnabled from '../../../../assets/img/model-plans/Circle_enabled.png'
import CircleDisabled from '../../../../assets/img/model-plans/Circle_disabled.png'
import ViewButtonContainerManipulation from './ViewButtonsManipulation/ViewButtonContainerManipulation'
import usePointsOfView from '../../../../hooks/inspection/usePointsOfView'
import ImageWithDotsManipulation from './ImageWithDotsManipulation'
import { PointOfView_GetResponse_NetData, getMediaContent } from '../../../../api/chatApi/chatApi'
import chatApi from '../../../../api/chatApi'
import { useQuery } from 'react-query'
import { CircularProgress, Fade, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Snackbar, TextField, InputAdornment, IconButton } from '@material-ui/core'
import { Manipulation } from '../../../../api/chatApi/chatApi'
import { Alert } from '@material-ui/lab'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme =>
  createStyles({
    imgIcon: {
      width: '60%',
      height: '60%',
      objectFit: 'contain',
      zIndex: 2,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        width: '75%',
        height: '75%'
      }
    },
    imageContainer: {
      width: '60px',
      height: '60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        width: '50px',
        height: '50px',
      }
    },
    imgWrapper: {
      width: '50px',
      height: '50px',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        width: '40px',
        height: '40px'
      }
    },
    activeCircle: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: '2px solid #2196F3',
      borderRadius: '50%',
      zIndex: 1,
    },
    inactiveCircle: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      border: '2px solid #9E9E9E',
      borderRadius: '50%',
      zIndex: 1,
    },
    root: {
      position: 'relative'
    },
    progress_container: {
      position: 'absolute',
      background: 'rgba(255, 255, 255, 0.6)',
      backdropFilter: 'blur(5px)',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999,
      display: 'flex',
      alignSelf: 'center',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    },
    headerBlockMain: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexWrap: 'nowrap',
      overflowX: 'auto',
      marginBottom: 5,
    },
    headerBlock: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexWrap: 'nowrap',
      overflowX: 'auto',
      marginBottom: 5,
      paddingLeft: 15,
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(1),
        flexWrap: 'wrap',
        gap: theme.spacing(1)
      }
    },
    detailBlock: {
      position: 'relative',
      height: 'auto',
      minHeight: '400px',
      paddingTop: 8,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        minHeight: '400px',
        paddingTop: 0
      }
    },
    viewButtonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      minWidth: '90px',
      position: 'relative',
      marginTop: '8px',
      padding: '0 5px',
      [theme.breakpoints.down('sm')]: {
        minWidth: '70px',
        padding: '0 3px',
        marginTop: '4px'
      }
    },
    viewButtonText: {
      marginTop: '6px',
      fontSize: '0.8rem',
      color: '#9E9E9E',
      cursor: 'pointer',
      lineHeight: 1.2,
      [theme.breakpoints.down('sm')]: {
        marginTop: '4px',
        fontSize: '0.75rem',
      }
    },
    viewButtonTextActive: {
      marginTop: '6px',
      fontSize: '0.8rem',
      color: '#2196F3',
      fontWeight: 600,
      cursor: 'pointer',
      lineHeight: 1.2,
      [theme.breakpoints.down('sm')]: {
        marginTop: '4px',
        fontSize: '0.75rem',
      }
    },
    arrow: {
      color: `${theme.palette.grey}`,
    },
    manipulationsColumn: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: theme.spacing(1),
      width: '100%',
      maxWidth: '1000px',
      margin: '20px auto 50px',
      '& > *': {
        flexBasis: 'calc(20% - 8px)',
        maxWidth: 'calc(20% - 8px)',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '800px',
        '& > *': {
          flexBasis: 'calc(25% - 8px)',
          maxWidth: 'calc(25% - 8px)',
        }
      },
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: theme.palette.background.default,
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[400],
        borderRadius: '4px',
        '&:hover': {
          background: theme.palette.grey[500],
        },
      },
    },
    manipulationTitle: {
      textAlign: 'center',
      fontWeight: 'bold',
      marginBottom: theme.spacing(2),
    },
    manipulationItem: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '190px',
      maxWidth: '190px',
      alignItems: 'center',
      padding: theme.spacing(0.1),
      borderRadius: theme.spacing(1),
      transition: 'transform 0.2s ease-in-out',
      margin: '0 auto',
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.8,
        transform: 'scale(1.05)',
      },
    },
    manipulationImage: {
      width: '70px',
      height: '70px',
      marginBottom: theme.spacing(1),
      borderRadius: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '60px',
        height: '60px',
      },
    },
    manipulationName: {
      textAlign: 'center',
      fontSize: '0.875rem',
      lineHeight: '1.2',
      wordWrap: 'break-word',
      padding: theme.spacing(0.5),
      minHeight: '4em',
      maxHeight: '4em',
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      whiteSpace: 'pre-wrap',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
        minHeight: '4.5em',
        maxHeight: '4.5em',
      },
    },
    tooltip: {
      backgroundColor: '#1876d1',
      color: 'white',
      boxShadow: theme.shadows[2],
      fontSize: '0.95rem',
      padding: '4px 8px',
      maxWidth: 200,
      textAlign: 'center',
      '& .MuiTooltip-arrow': {
        color: '#1876d1',
      },
    },
    injectionItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      cursor: 'pointer',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
        backgroundColor: "#d9e7f7",
        transition: 'background-color 0.3s ease',
      },
    },
    injectionName: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(0.5),
    },
    dialogPaper: {
      width: '40%',
      maxWidth: '80vw',
    },
    mobileSideControls: {
      display: 'none',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        gap: theme.spacing(0.25),
        padding: theme.spacing(0.25),
      }
    },
    mobileSideButton: {
      padding: theme.spacing(0.5),
      minWidth: '45px',
      flex: '1 1 0',
      borderRadius: '4px',
      textAlign: 'center',
      fontWeight: 'normal',
      backgroundColor: theme.palette.grey[200],
      fontSize: '0.75rem',
      '&.active': {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        fontWeight: 'bold',
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.4),
        fontSize: '0.7rem',
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(0.3),
        fontSize: '0.65rem',
        minWidth: '35px',
      }
    },
  })
)

interface Props {
  paramData: any;
  onParamClick: (paramName: string) => void;
  onHumanClick: (event: any) => void;
  onInstrumentSelect?: (instrumentId: number, isCorrect: boolean) => void;
}

const partOfBodyIdImageMap = new Map([
  [-1, { active: Plan3d, notActive: Plan3dDisbaled }],
  [1, { active: Body, notActive: BodyDisbaled, name: "Общий вид" }],
  [2, { active: Head, notActive: HeadDisabled, name: "Голова" }],
  [3, { active: Chest, notActive: ChestDisabled, name: "Грудная клетка" }],
  [4, { active: Stomach, notActive: StomachDisabled, name: "Живот" }],
  [5, { active: Hands, notActive: HandsDisabled, name: "Суставы кистей" }],
  [6, { active: Photo, notActive: PhotoDisabled, name: "Фото" }],
  [7, { active: Knee, notActive: KneeDisabled, name: "Колени" }],
  [8, { active: Pelvis, notActive: PelvisDisabled, name: "Тазобедренный сустав" }],
  [9, { active: Elbow, notActive: ElbowDisabled, name: "Локоть" }],
  [10, { active: AnkleJoints, notActive: AnkleJointsDisabled, name: "Голеностопный сустав" }],
  [11, { active: Shoulder, notActive: ShoulderDisabled, name: "Плечо" }],
  [12, { active: Feet, notActive: FeetDisabled, name: "Стопы" }],
])

export default function HumanParamsManipulation({
  paramData,
  onParamClick,
  onHumanClick,
  onInstrumentSelect
}: Props) {
  const classes = useStyles()
  const imageContainerRef = React.useRef<HTMLDivElement>(null);
  const [showToast, setShowToast] = useState(false);
  const [selectedInjection, setSelectedInjection] = useState<string>('');
  const [isInjectionCorrect, setIsInjectionCorrect] = useState<boolean>(false);
  const [manipulationToast, setManipulationToast] = useState({
    show: false,
    message: '',
    severity: 'success' as 'success' | 'error'
  });

  const [loading, setLoading] = React.useState(true)
  const [imagesLoaded, setImagesLoaded] = React.useState(false)
  const [pointsLoaded, setPointsLoaded] = React.useState(false)

  const [selectedMethodId, setSelectedMethodId] = useState<number | null | undefined>(1)
  const [selectedBodyPartId, setSelectedBodyPartId] = useState<number | null | undefined>(1)
  const [selectedSideId, setSelectedSideId] = useState<number | undefined>(1)
  const [bgImage, setBgImage] = useState<string | undefined>()
  const [dotsList, setDotsList] = useState<Array<any>>([])
  const [selectedManipulation, setSelectedManipulation] = useState<Manipulation | null>(null);
  const [selectedPoint, setSelectedPoint] = useState<{ x: number, y: number } | null>(null);
  const [showInjections, setShowInjections] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedInstruments, setSelectedInstruments] = useState<{ [key: number]: boolean }>({});
  const [isCorrectInstrument, setIsCorrectInstrument] = useState<{ [key: number]: boolean }>({});

  // Определяем, является ли устройство мобильным
  const [isMobile, setIsMobile] = useState(false);

  // Добавляем обработчик изменения размера экрана для определения мобильного устройства
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 960); // Точка перехода на мобильную версию
    };

    checkIsMobile();

    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  useEffect(() => {
    if (showInjections) {
      setSearchQuery('');
    }
  }, [showInjections]);

  const currentTask: any = useQuery(['currentTask'], async () => {
    const result = await chatApi.unfinishedTask().then(it => it.result)
    return result
  })

  const inspectionBodyParts = useQuery(
    ['usePartsOfBody', { selectedMethodId }],
    async () => {
      if (!selectedMethodId) return
      const result = await chatApi
        .getPartsOfBodyByTask(`${selectedMethodId}`)
        .then((it: any) => it.result)
      return result
    }
  )

  const inspectionSides = useQuery(
    ['useInspectionSides', { selectedMethodId, selectedBodyPartId }],
    async () => {
      if (!selectedMethodId) {
        return;
      }
      if (!selectedBodyPartId) {
        return;
      }
      const result = await chatApi
        .getConstructorsInspectionsideByTask(
          `${selectedMethodId}`,
          `${selectedBodyPartId}`
        )
        .then((it: any) => it.result)
      if (result.length) setSelectedSideId(result[0].id)
      return result
    }
  )

  const bodypartimage: any = useQuery(
    [
      'bodypartimage',
      { selectedSideId, selectedBodyPartId, selectedMethodId, currentTask }
    ],
    async () => {
      if (!selectedSideId) {
        return;
      }
      if (!selectedBodyPartId) {
        return;
      }
      if (!selectedMethodId) {
        return;
      }
      if (!currentTask?.data) {
        return;
      }

      const result = await chatApi
        .getBodyPartImage(
          String(selectedSideId),
          String(selectedBodyPartId),
          String(selectedMethodId),
          String(currentTask?.data?.task?.patientModel?.id)
        )
        .then(it => {
          return it.result;
        });

      if (result?.[0]?.description) {
        setBgImage(result[0].description);
      }

      return result;
    },
    {
      refetchOnMount: true,
      enabled: !!selectedSideId && !!selectedBodyPartId && !!selectedMethodId && !!currentTask?.data
    }
  );

  const [selectedToolsDots, setSelectedToolsDots] = useState<number[]>([])

  const [pointsByTask, setPointsByTask] = useState<PointManipulationInterface[]>([])

  async function getPointsByTasks() {
    try {
      if (!currentTask?.data?.taskId) {
        return;
      }
      const response = await getPointManipulation(currentTask.data.taskId)

      const toolPoints = response.data.PointManipulation.filter(
        (point: PointManipulationInterface) =>
          point.type_click === 2 && !point.del
      );

      setSelectedToolsDots(toolPoints)
      setPointsByTask(response.data.PointManipulation)
      setPointsLoaded(true)
    } catch (err) {
      console.log(`при получении точек произошла ошибка: ${err}`)
      setPointsByTask([])
      setPointsLoaded(true)
    }
  }

  useEffect(() => {
    getPointsByTasks()
  }, [currentTask?.data?.taskId])



  const getDots = async () => {
    if (!pointsByTask || pointsByTask.length === 0) {
      return;
    }

    try {
      const pointStatesResponse = await getPointManipulationUsertaskproceed();
      const pointStates = pointStatesResponse.data.point_manipulation_usertaskproceed;

      const results = pointsByTask
        .filter(el =>
          el.inspectionsideid === selectedSideId &&
          el.partofbodyid === selectedBodyPartId
        )
        .map(el => {
          const pointState = pointStates.find(
            (item: any) =>
              item.type_click === 1 &&
              item.point_manipulation_operations_type_id === el.id
          );

          return {
            ...el,
            x: el.point_x,
            y: el.point_y,
            cursor: 'pointer',
            selectedInjection: pointState?.text_out,
            isCorrect: pointState?.is_correct
          };
        });
      setDotsList(results);
      return results;
    } catch (err) {
      const results = pointsByTask
        .filter(el =>
          el.inspectionsideid === selectedSideId &&
          el.partofbodyid === selectedBodyPartId
        )
        .map(el => ({
          ...el,
          x: el.point_x,
          y: el.point_y,
          cursor: 'pointer'
        }));

      setDotsList(results);
      return results;
    }
  }

  // Загружаем точки сразу после установки начальных значений
  useEffect(() => {
    try {
      const loadInitialData = async () => {
        if (selectedMethodId && selectedBodyPartId && selectedSideId) {
          if (!pointsByTask || pointsByTask.length === 0) {
            await getPointsByTasks();
          }

          if (pointsByTask && pointsByTask.length > 0) {
            await getDots();
          }
        }
      };

      loadInitialData();
    } catch (err) {
      console.log(`при загрузке данных произошла ошибка: ${err}`)
    }
  }, [selectedMethodId, selectedBodyPartId, selectedSideId]);


  useEffect(() => {
    getDots();
  }, [
    selectedMethodId,
    selectedSideId,
    selectedBodyPartId,
    pointsByTask
  ]);

  useEffect(() => {
    const images = [
      Body, BodyDisbaled, Head, HeadDisabled, Chest, ChestDisabled,
      Stomach, StomachDisabled, AnkleJoints, AnkleJointsDisabled,
      Pelvis, PelvisDisabled, Elbow, ElbowDisabled, Feet, FeetDisabled,
      Hands, HandsDisabled, Knee, KneeDisabled, Photo, PhotoDisabled,
      Shoulder, ShoulderDisabled, CircleEnabled, CircleDisabled
    ];

    Promise.all(images.map(src => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
      });
    })).then(() => {
      setImagesLoaded(true);
    });
  }, []);

  const pointsOfView = usePointsOfView(
    selectedSideId?.toString(),
    selectedBodyPartId?.toString(),
    selectedMethodId?.toString()
  );

  React.useEffect(() => {
    setLoading(
      !imagesLoaded ||
      !pointsLoaded ||
      currentTask.isLoading ||
      inspectionBodyParts.isLoading ||
      inspectionSides.isLoading ||
      bodypartimage.isLoading ||
      (pointsOfView.isLoading && !pointsOfView.isIdle)
    );
  }, [
    imagesLoaded,
    pointsLoaded,
    currentTask.isLoading,
    inspectionBodyParts.isLoading,
    inspectionSides.isLoading,
    bodypartimage.isLoading,
    pointsOfView.isLoading,
    pointsOfView.isIdle
  ]);

  const selectSideId = async (id: number) => {
    if (availableSideIds.has(id)) {
      try {
        await setSelectedSideId(id);
      } catch (err) {
        console.log(`при отправке данных произошла ошибка: ${err}`)
      }
    }
  };

  const [dotInjectionParams, setDotInjectionParams] = useState<any>({
    point_manipulation_id: 0,
    point_manipulation_operations_type_id: 1,
    value: 0
  })

  const handleImageClick = (dot: any) => {
    const currentDot = dotsList.find(d => d.id === dot.id);
    if (!currentDot) {
      return;
    }

    // Проверяем цвет точки в текущем состоянии
    if (currentDot.preFillColor === 'red' || currentDot.preFillColor === 'green') {
      return;
    }
    setDotInjectionParams({
      point_manipulation_id: dot.id,
      point_manipulation_operations_type_id: 1,
      value: 0
    });

    setShowInjections(true);
  };

  // Обработчик для закрытия меню при клике вне его
  useEffect(() => {
    const handleDocumentClick = (e: MouseEvent) => {
      if (!imageContainerRef.current) {
        return;
      }

      if (!imageContainerRef.current.contains(e.target as Node)) {
        setShowInjections(false);
      }
    };

    if (showInjections) {
      document.addEventListener('click', handleDocumentClick);
    }

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [showInjections]);



  const handleInjectionSelect = async (injection: any) => {
    setShowInjections(false);
    setSelectedPoint(null);

    const data = {
      ...dotInjectionParams,
      value: injection.id
    }

    try {
      await setPointManipulationUsertaskproceedType1(data);
      const response = await getPointManipulationUsertaskproceed();

      const updatedDots = dotsList.map(dot => {
        const pointResponse = response.data.point_manipulation_usertaskproceed.find(
          (item: any) =>
            item.type_click === 1 &&
            item.point_manipulation_operations_type_id === dot.id
        );

        if (pointResponse && dot.id === dotInjectionParams.point_manipulation_id) {
          return {
            ...dot,
            selectedInjection: injection.medications_type_intake,
            isCorrect: pointResponse.is_correct,
          };
        }
        return dot;
      });

      setDotsList(updatedDots);

      const pointResponse = response.data.point_manipulation_usertaskproceed.find(
        (item: any) =>
          item.type_click === 1 &&
          item.point_manipulation_operations_type_id === dotInjectionParams.point_manipulation_id
      );

      setSelectedInjection(injection.medications_type_intake);
      setIsInjectionCorrect(pointResponse?.is_correct || false);
      setShowToast(true);

    } catch (err) {
      console.log(`при отправке данных произошла ошибка: ${err}`);
    }
  };

  // получаем состояние всех инструментов
  useEffect(() => {
    const fetchInstrumentsState = async () => {
      try {
        const result = await getPointManipulationUsertaskproceed();
        if (!result?.data?.point_manipulation_usertaskproceed) {
          console.log('Нет данных о состоянии инструментов');
          return;
        }

        const instrumentStates = result.data.point_manipulation_usertaskproceed
          .filter((item: any) => item.type_click === 2)
          .reduce((acc: any, item: any) => {
            acc.selected[item.value] = true;
            acc.correct[item.value] = item.is_correct;
            return acc;
          }, { selected: {}, correct: {} });

        setSelectedInstruments(instrumentStates.selected);
        setIsCorrectInstrument(instrumentStates.correct);
      } catch (err) {
        console.log(`при получении состояния инструментов произошла ошибка: ${err}`);
      }
    };

    fetchInstrumentsState();
  }, []);

  // При первой загрузке получаем состояние всех точек
  useEffect(() => {
    const fetchInitialState = async () => {
      try {
        const result = await getPointManipulationUsertaskproceed();
        if (!result?.data?.point_manipulation_usertaskproceed) {
          console.log('Нет данных о состоянии точек');
          return;
        }

        const pointStates = result.data.point_manipulation_usertaskproceed;

        setDotsList(prevDots => {
          return prevDots.map(dot => {
            const pointState = pointStates.find(
              (item: any) =>
                item.type_click === 1 &&
                item.point_manipulation_operations_type_id === dot.id
            );

            if (pointState) {
              return {
                ...dot,
                preFillColor: pointState.is_correct ? 'green' : 'red',
                strokeColor: pointState.is_correct ? 'green' : 'red',
                selectedInjection: pointState.value ? pointState.value : undefined
              };
            }
            return dot;
          });
        });
      } catch (err) {
        console.log(`при получении состояния точек произошла ошибка: ${err}`);
      }
    };

    fetchInitialState();
  }, []);

  // для автоматического скрытия снекбара
  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);


  const [toolsRightBar, setToolsRightBar] = useState<any>([]);
  const [medicationsLeftBar, setMedicationsLeftBar] = useState<any>([]);

  const getToolsRightBar = async () => {
    try {
      const result = await getTools();
      setToolsRightBar(result.data.tools);
    } catch (err) {
      console.log(`при получении инструментов произошла ошибка: ${err}`)
    }
  }

  useEffect(() => {
    getToolsRightBar();
    getMedicationsLeftBar();
  }, []);

  const getMedicationsLeftBar = async () => {
    try {
      const result = await getMedicationsTypeIntake();
      setMedicationsLeftBar(result.data.medications_type_intake);
    } catch (err) {
      console.log(`при получении лекарств произошла ошибка: ${err}`)
    }
  };

  // Получаем уникальные ID частей тела, для которых есть точки
  const availableBodyPartIds = React.useMemo(() => {
    if (!pointsByTask || pointsByTask.length === 0) {
      return new Set<number>();
    }
    return new Set(pointsByTask.map(point => point.partofbodyid));
  }, [pointsByTask]);

  // Получаем уникальные ID видов для выбранной части тела
  const availableSideIds = React.useMemo(() => {
    if (!pointsByTask || pointsByTask.length === 0) {
      return new Set<number>();
    }
    return new Set(
      pointsByTask
        .filter(point => point.partofbodyid === selectedBodyPartId)
        .map(point => point.inspectionsideid)
    );
  }, [pointsByTask, selectedBodyPartId]);

  // Фильтруем части тела, оставляя только те, для которых есть точки
  const filteredBodyParts = useMemo(() => {
    const mockInspectionBodyParts = [
      { id: 1, name: 'Общий вид', description: 'Общий вид', image: Body, disabledImage: BodyDisbaled },
      { id: 2, name: 'Голова', description: 'Голова', image: Head, disabledImage: HeadDisabled },
      { id: 3, name: 'Грудная клетка', description: 'Грудная клетка', image: Chest, disabledImage: ChestDisabled },
      { id: 4, name: 'Живот', description: 'Живот', image: Stomach, disabledImage: StomachDisabled },
      { id: 5, name: 'Кисти', description: 'Кисти', image: Hands, disabledImage: HandsDisabled },
      { id: 6, name: 'Фото', description: 'Фото', image: Photo, disabledImage: PhotoDisabled },
      { id: 7, name: 'Колени', description: 'Колени', image: Knee, disabledImage: KneeDisabled },
      { id: 9, name: 'Стопы', description: 'Стопы', image: Feet, disabledImage: FeetDisabled },
    ];

    return mockInspectionBodyParts.filter(bodyPart =>
      availableBodyPartIds.has(bodyPart.id)
    );
  }, [availableBodyPartIds]);

  const sides = [
    { id: 1, value: 'Спереди' },
    { id: 2, value: 'Сзади' },
    { id: 3, value: 'Слева' },
    { id: 4, value: 'Справа' }
  ];

  const filteredSides = useMemo(() => {
    const sidesWithPoints = sides.filter(side =>
      availableSideIds.has(side.id)
    );

    if (selectedSideId && !sidesWithPoints.some(side => side.id === selectedSideId)) {
      const currentSide = sides.find(side => side.id === selectedSideId);
      if (currentSide) {
        return [...sidesWithPoints, currentSide];
      }
    }

    return sidesWithPoints;
  }, [availableSideIds, selectedSideId]);


  useEffect(() => {
    if (selectedBodyPartId && pointsByTask.length > 0) {
      const newAvailableSideIds = new Set(
        pointsByTask
          .filter(point => point.partofbodyid === selectedBodyPartId)
          .map(point => point.inspectionsideid)
      );
      
      if (!newAvailableSideIds.has(selectedSideId)) {
        const firstAvailableSide = sides.find(side =>
          newAvailableSideIds.has(side.id)
        );
        
        if (firstAvailableSide) {
          console.log(`Switching side from ${selectedSideId} to ${firstAvailableSide.id} for body part ${selectedBodyPartId}`);
          setSelectedSideId(firstAvailableSide.id);
        }
      }
    }
  }, [selectedBodyPartId, pointsByTask]);

  const selectBodyPart = (bodyPartId: number) => {
    if (bodyPartId === selectedBodyPartId) {
      return;
    }
    
    setSelectedBodyPartId(bodyPartId);
    
    const availableSidesForNewPart = new Set(
      pointsByTask
        .filter(point => point.partofbodyid === bodyPartId)
        .map(point => point.inspectionsideid)
    );
    
    if (!availableSidesForNewPart.has(selectedSideId)) {
      const firstAvailable = sides.find(side => 
        availableSidesForNewPart.has(side.id)
      );
      
      if (firstAvailable) {
        console.log(`Immediately switching side to ${firstAvailable.id} for new body part ${bodyPartId}`);
        setSelectedSideId(firstAvailable.id);
      }
    }
  };

  const handleManipulationClick = async (manipulation: any) => {
    if (selectedInstruments[manipulation.id]) {
      return;
    }

    try {
      const dataToSend = {
        point_manipulation_operations_type_id: 1,
        value: manipulation.id
      }
      await setPointManipulationUsertaskproceedType2(dataToSend)
      const result = await getPointManipulationUsertaskproceed()

      setSelectedInstruments(prev => ({
        ...prev,
        [manipulation.id]: true
      }));

      const instrumentInfo = result.data.point_manipulation_usertaskproceed.find(
        (item: any) => item.value === manipulation.id && item.type_click === 2
      );

      if (instrumentInfo) {
        setIsCorrectInstrument(prev => ({
          ...prev,
          [manipulation.id]: instrumentInfo.is_correct
        }));

        setManipulationToast({
          show: true,
          message: instrumentInfo.is_correct ? "Правильный ответ" : "Неправильный ответ",
          severity: instrumentInfo.is_correct ? 'success' : 'error'
        });

        if (onInstrumentSelect) {
          onInstrumentSelect(manipulation.id, instrumentInfo.is_correct);
        }
      }
    } catch (err) {
      console.log(`при отправке данных произошла ошибка: ${err}`)
    }
  }

  const filteredInjections = medicationsLeftBar.filter(injection =>
    injection.medications_type_intake.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (manipulationToast.show) {
      const timer = setTimeout(() => {
        setManipulationToast(prev => ({ ...prev, show: false }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [manipulationToast.show]);

  return (
    <SimpleCard padded={false}>
      <div className={classes.root}>
        {loading && (
          <div className={classes.progress_container}>
            <CircularProgress />
          </div>
        )}
        <div className={classes.detailBlock}>
          <div className={classes.headerBlock}>
            {filteredBodyParts.map(it => {
              const image = partOfBodyIdImageMap.get(it.id);
              const isActive = selectedBodyPartId === it.id;

              return (
                <Tooltip title={it.name} key={it.id} arrow classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}>
                  <div
                    key={it.id}
                    onClick={() => {
                      selectBodyPart(it.id);
                    }}
                    className={classes.viewButtonContainer}
                  >
                    <ViewButtonContainerManipulation>
                      <div className={classes.imgWrapper}>
                        <div
                          className={isActive ? classes.activeCircle : classes.inactiveCircle}
                        />
                        {selectedBodyPartId === it.id ? (
                          <img
                            alt=''
                            src={image?.active}
                            className={classes.imgIcon}
                            onError={(e) => console.error('Error loading image:', image?.active)}
                          />
                        ) : (
                          <img
                            alt=''
                            src={image?.notActive}
                            className={classes.imgIcon}
                            onError={(e) => console.error('Error loading image:', image?.notActive)}
                          />
                        )}
                      </div>
                    </ViewButtonContainerManipulation>
                    <div className={isActive ? classes.viewButtonTextActive : classes.viewButtonText}>
                      {it.name}
                    </div>
                  </div>
                </Tooltip>
              );
            })}
          </div>

          {/* Мобильное управление для выбора вида */}
          <div className={classes.mobileSideControls}>
            {filteredSides.map(side => (
              <div
                key={side.id}
                className={`${classes.mobileSideButton} ${side.id === selectedSideId ? 'active' : ''}`}
                onClick={() => selectSideId(side.id)}
              >
                {side.value}
              </div>
            ))}
          </div>

          {!loading && (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                marginBottom: '20px'
              }}>
                <div style={{
                  position: 'absolute',
                  left: 30,
                  width: '10%',
                  zIndex: 1000,
                  display: isMobile ? 'none' : 'block' // Скрываем на мобильных устройствах
                }}>
                  <DetailViewBtnContainerManipulation
                    selectedId={selectedSideId}
                    onSelect={id => selectSideId(id)}
                    items={filteredSides}
                  />
                </div>
                <div style={{
                  position: 'relative',
                  width: isMobile ? '100%' : '90%', // На мобильных устройствах занимаем всю ширину
                  marginLeft: isMobile ? 0 : '10%'  // На мобильных убираем отступ слева
                }} ref={imageContainerRef}>
                  {bgImage && (
                    <ImageWithDotsManipulation
                      image={bgImage}
                      dots={dotsList}
                      selectedBodyPartId={selectedBodyPartId}
                      onSelectDot={handleImageClick}
                      selectedSideId={selectedSideId}
                    />
                  )}
                </div>
              </div>
              <div className={classes.manipulationsColumn}>
                {toolsRightBar.map((manipulation) => (
                  <Tooltip
                    key={manipulation.id}
                    title={selectedInstruments[manipulation.id]
                      ? (isCorrectInstrument[manipulation.id]
                        ? "Правильный ответ"
                        : "Неправильный ответ")
                      : "Не выбрано"}
                    placement="top"
                    enterDelay={300}
                    arrow
                    classes={{
                      tooltip: classes.tooltip
                    }}
                  >
                    <div
                      className={classes.manipulationItem}
                      onClick={() => handleManipulationClick(manipulation)}
                      style={{
                        cursor: selectedInstruments[manipulation.id] ? 'not-allowed' : 'pointer'
                      }}
                    >
                      <div
                        className={classes.manipulationImage}
                        style={{
                          backgroundImage: `url(data:image/png;base64,${selectedInstruments[manipulation.id]
                            ? (isCorrectInstrument[manipulation.id] ? manipulation.ico_hover : manipulation.ico)
                            : manipulation.ico})`,
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          backgroundColor: 'white',
                          boxShadow: selectedInstruments[manipulation.id]
                            ? (isCorrectInstrument[manipulation.id]
                              ? '0 0 10px 5px rgb(0, 128, 1)'
                              : '0 0 10px 5px rgb(255, 102, 94)')
                            : '0 0 10px 5px rgb(137, 136, 136)'
                        }}
                      />
                      <div className={classes.manipulationName}>{manipulation.tools}</div>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Snackbar для инъекций */}
        <Snackbar
          open={showToast}
          autoHideDuration={3000}
          style={{
            position: 'fixed',
            top: '70px',
            right: '20px',
            zIndex: 10000
          }}
          onClose={() => setShowToast(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            severity={isInjectionCorrect ? "success" : "error"}
            onClose={() => setShowToast(false)}
          >
            {isInjectionCorrect ? 'Правильный ответ' : 'Неправильный ответ'}
          </Alert>
        </Snackbar>

        {/* Snackbar для манипуляций */}
        <Snackbar
          open={manipulationToast.show}
          autoHideDuration={3000}
          style={{
            position: 'fixed',
            top: '70px',
            right: '20px',
            zIndex: 10000
          }}
          onClose={() => setManipulationToast(prev => ({ ...prev, show: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert severity={manipulationToast.severity} onClose={() => setManipulationToast(prev => ({ ...prev, show: false }))}>
            {manipulationToast.message}
          </Alert>
        </Snackbar>
      </div>

      {/* Модальное окно для инъекций */}
      <Dialog
        open={showInjections}
        onClose={() => setShowInjections(false)}
        maxWidth="md"
        PaperProps={{
          style: {
            width: '60%',
            minWidth: '60%',
            height: '80vh'
          }
        }}
      >
        <div style={{
          padding: '16px 16px 16px 16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#bfd7f2',
          width: '100%',
          fontWeight: 'bold',
          fontSize: '18px'
        }}>
          Доступные инъекции
        </div>
        <DialogContent style={{
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 120px)'
        }}>
          <div style={{
            padding: '16px 16px 10px 16px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 1
          }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Поиск..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              size="small"
              InputProps={{
                endAdornment: searchQuery ? (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="clear search"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSearchQuery('');
                      }}
                      onMouseDown={(e) => e.stopPropagation()}
                      edge="end"
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            />
          </div>
          <div style={{
            padding: '16px',
            overflowY: 'auto',
            flex: 1
          }}>
            {filteredInjections.map((injection) => (
              <div
                key={injection.id}
                className={classes.injectionItem}
                onClick={(e) => {
                  e.stopPropagation();
                  handleInjectionSelect(injection);
                }}
              >
                <span className={classes.injectionName}>{injection.medications_type_intake}</span>
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions style={{
          borderTop: '1px solid rgba(0, 0, 0, 0.12)',
          padding: '16px'
        }}>
          <Button onClick={() => setShowInjections(false)} color="primary">
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>

      {/* Модальное окно для манипуляций */}
      <Dialog
        open={selectedManipulation !== null}
        onClose={() => setSelectedManipulation(null)}
        classes={{
          paper: classes.dialogPaper
        }}
        fullWidth={false}
      >
        <DialogTitle >{selectedManipulation?.tools}</DialogTitle>
        <DialogContent>{selectedManipulation?.tools}</DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedManipulation(null)} color="primary">
            ОК
          </Button>
        </DialogActions>
      </Dialog>
    </SimpleCard>
  )
}

